(function ($) {
   'use strict';

   $.validator.addMethod('summernoteRequired', function (value, element) {
      const $el = $(element);

      if (!$el.data('summernote')) return true;

      return !$el.summernote('isEmpty');
   }, 'Este campo é obrigatório');

   const originalInit = $.validator.prototype.init;

   $.validator.prototype.init = function () {
      $.extend(this.settings, {
         errorClass: 'is-invalid',
         validClass: 'is-valid',
         errorElement: 'div',
         ignore: ':hidden:not(textarea):not(.crop-upload)',

         errorPlacement: function (error, element) {
            element = element instanceof jQuery ? element[0] : element;
            const $el = $(element);
            error.addClass('invalid-feedback');

            // Summernote (somente coloca o erro, não valida ainda)
            if ($el.hasClass('summernote') || $el.next('.note-editor').length) {
               const container = $el.next('.note-editor');
               if (container.length) {
                  container.after(error);
               } else {
                  error.insertAfter($el);
               }
               return;
            }

            // Checkbox / radio
            if (element.type === 'checkbox' || element.type === 'radio') {
               const dynamicContainer = $('[data-name="' + element.name + '"]');
               if (dynamicContainer.length) {
                  dynamicContainer.append(error.addClass('d-block'));
               } else {
                  $el.closest('.form-group, .form-check').append(error.addClass('d-block'));
               }
               return;
            }

            // Select2
            if ($el.hasClass('select2-hidden-accessible')) {
               error.insertAfter($el.next('.select2-container'));
               return;
            }

            // Padrão
            error.insertAfter($el);
         },

         highlight: function (element) {
            const $el = $(element);

            // Summernote: a textarea real fica display:none, então marcar
            // ela de is-invalid não aparece pra ninguém — quem precisa da
            // classe é o wrapper visível (.note-editor), inserido logo
            // depois dela. Classe própria (não "is-invalid"): o jQuery
            // Validate rastreia suas próprias mensagens de erro via
            // `div.${errorClass}` (errors()/prepareForm()) — se o wrapper
            // (uma <div>) também tivesse "is-invalid", ele seria confundido
            // com uma mensagem de erro e teria o conteúdo apagado
            // (hideThese() chama error.text("")) no próximo resetForm().
            if ($el.hasClass('summernote') || $el.next('.note-editor').length) {
               $el.next('.note-editor').addClass('note-editor-invalid');
               return;
            }

            if (element.type === 'checkbox' || element.type === 'radio') {
               const $group = $(`[name="${element.name}"]`);
               $group.addClass('is-invalid').removeClass('is-valid');
               $group.closest('.form-check').find('.form-check-label')
                  .addClass('text-danger').removeClass('text-success');
            } else if ($el.hasClass('select2-hidden-accessible')) {
               $el.next('.select2-container').find('.select2-selection')
                  .addClass('is-invalid');
            } else {
               $el.addClass('is-invalid').removeClass('is-valid');
            }
         },

         unhighlight: function (element) {
            const $el = $(element);

            // Summernote: mesmo raciocínio do highlight acima — a classe
            // vai no wrapper visível, não na textarea escondida.
            if ($el.hasClass('summernote') || $el.next('.note-editor').length) {
               $el.next('.note-editor').removeClass('note-editor-invalid');
               return;
            }

            if (element.type === 'checkbox' || element.type === 'radio') {
               const $group = $(`[name="${element.name}"]`);
               $group.removeClass('is-invalid').addClass('is-valid');
               $group.closest('.form-check').find('.form-check-label')
                  .removeClass('text-danger').addClass('text-success');
            } else if ($el.hasClass('select2-hidden-accessible')) {
               $el.next('.select2-container').find('.select2-selection')
                  .removeClass('is-invalid');
            } else {
               $el.removeClass('is-invalid').addClass('is-valid');
            }
         }
      });

      return originalInit.apply(this, arguments);
   };

   // Auto-revalidação para checkboxes, radios e selects
   $(document).on('change', 'input[type="checkbox"], input[type="radio"], .select2-hidden-accessible', function () {
      const $form = $(this).closest('form');
      const validator = $form.data('validator');
      if (validator) validator.element(this);
   });

   $(document).on('summernote.change paste', '.summernote', function () {
      // O evento dispara na própria <textarea class="summernote"> (é nela
      // que o Summernote chama this.$note.trigger('summernote.<nome>', ...)
      // internamente) — .note-editor é irmã, não ancestral, dela; usar
      // .closest() nunca encontrava nada e este listener era um no-op.
      const $textarea = $(this);

      // Ignora sets programáticos (initSummernote() populando o campo ao
      // abrir o modal, seja com valor vazio ou existente) — só o usuário
      // digitando/colando deve disparar revalidação em tempo real. Sem
      // isso, todo "Adicionar" já nasce marcado como inválido antes de
      // qualquer interação.
      if ($textarea.data('summernote-seeding')) {
         return;
      }

      // sincroniza valor
      $textarea.val(
         $textarea.summernote('isEmpty') ? '' : $textarea.summernote('code')
      );

      // notifica validator — mesmo padrão do auto-revalidação de
      // checkbox/radio/select2 acima: a textarea fica display:none (quem o
      // usuário edita de fato é o .note-editable ao lado), então nunca
      // dispara os eventos nativos (keyup/focusout) que o jQuery Validate
      // escuta por padrão pra revalidar em tempo real — precisa forçar via
      // validator.element().
      const $form = $textarea.closest('form');
      const validator = $form.data('validator');
      if (validator) validator.element(this);
   });


})(jQuery);
